import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 21l-4 -7l6.5 -11","key":"svg-0"}],["path",{"d":"M7 7l2 3.5l-3 4.5","key":"svg-1"}]]

/**
 * IconBrandXing
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQteGluZyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTYgMjFsLTQgLTdsNi41IC0xMSIgLz4KICA8cGF0aCBkPSJNNyA3bDIgMy41bC0zIDQuNSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/brand-xing
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandXing = createReactComponent('outline', 'brand-xing', 'BrandXing', __iconNode);

export default IconBrandXing;